import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  lifeInfo: {
    display: "flex",
    alignItems: "center"
  },
  lifeInfoItem: {
    minWidth: 16,
    padding: "0 4px",
    display: "flex",
    alignItems: "center",
    height: "100%"
  },
  lifeInfoTitle: {
    width: 32
  }
});
